import { Card, Row, Col } from 'react-bootstrap';
import { getApi } from '../api/endpoints';
import React, { useState, useEffect } from 'react';

const CirclesStats = () => {
  const [branchesApi] = getApi('branches');
  const [circleCount, setCircleCount] = useState(0);

  useEffect(() => {
    fetchCircles();
  }, [])

  const fetchCircles = async () => {
    try {
      const response = await branchesApi({ fields: 'options' }).unwrap();
      setCircleCount(response.data.branches.length);
    } catch (error) {
    }
  }

  return <div className="circle-stats mb-3">
    <Row>
      <Col lg={{ span: 2 }} className='mb-2'>
        <Card className='shadow'>
          <Card.Body>
            <Card.Title>Total Circles</Card.Title>
            <Card.Text>
              {circleCount}
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </div>
}

export default CirclesStats;
